<app-splash-screen></app-splash-screen>
<block-ui class="h-100">
  <router-outlet></router-outlet>
</block-ui>
